/** 与资产数据页 summary 请求共用的 filters，供分析报告总资产价值对齐 */
const KEY = 'asset_data_summary_filters_v1'

export function saveSummaryFilters(filters: Record<string, unknown>): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(filters))
  } catch {
    /* ignore */
  }
}

export function loadSummaryFilters(): Record<string, unknown> {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw) as unknown
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : {}
  } catch {
    return {}
  }
}
